<bw-icon-legacy color="var(--secondary-text)" iconName="close" [dismissedCta]="true" [coreTracking]="trackingDetail" (click)="exitActionTrigger()"></bw-icon-legacy>
